import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';

export default function Footer() {
  const { data } = useData();
  const site = data?.site || {};
  const nav = data?.site?.nav || [];
  const year = site.currentYear || new Date().getFullYear();

  return (
    <footer>
      <div className="footer-wrap">
        <div className="footer-left">
          <span id="footerBrand">{site.title || 'Preeyanka Mondal'}</span>
          <br />
          @{year}
        </div>

        <div className="footer-col">
          <h4>Site Map</h4>
          {nav.map(item =>
            item.external ? (
              <p key={item.label}>
                <a href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a>
              </p>
            ) : (
              <p key={item.label}><Link to={item.href}>{item.label}</Link></p>
            )
          )}
        </div>

        <div className="footer-col">
          <h4>Contact Details</h4>
          <p>
            <div className="footer-email">
              <i className="fa-solid fa-envelope"></i>
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </div>
          </p>
          <div className="social-icons">
            {site.linkedin && (
              <a href={site.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin"></i>
              </a>
            )}
            {site.behance && (
              <a href={site.behance} target="_blank" rel="noopener noreferrer" aria-label="Behance">
                <i className="fa-brands fa-behance"></i>
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
